import { Button } from "@/components/atoms/Button/Button";
import type React from "react";
import "./IconButtonWithText.scss";

interface IconButtonWithTextProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  ariaLabel?: string;
  iconName?: string; // material icon name
  svgIcon?: React.ReactNode; // custom SVG node
  className?: string;
}

export const IconButtonWithText: React.FC<IconButtonWithTextProps> = ({
  onClick,
  label,
  ariaLabel,
  iconName,
  svgIcon,
  className = "",
  ...rest
}) => {
  return (
    <Button
      buttonType={"clear"}
      aria-label={ariaLabel}
      className={`icon-button-with-text home-button ${className}`}
      onClick={onClick}
      {...rest}
    >
      {svgIcon ? svgIcon : <span className="material-icons">{iconName}</span>}
      <span className="icon-button-with-text__text home-button__text">{label}</span>
    </Button>
  );
};
